import { Box, LinearProgress, SxProps, Theme } from "@mui/material";
import React from "react";

export interface LinearProgressIndicatorProps {
  value?: number;
}

const getStyles = (value: number): SxProps<Theme> => {
  const isCompleted = value >= 100;

  return {
    "& .MuiLinearProgress-bar": {
      borderTopRightRadius: isCompleted ? "0" : "30px",
      borderBottomRightRadius: isCompleted ? "0" : "30px",
    },
  };
};

export const LinearProgressIndicator: React.FC<
  LinearProgressIndicatorProps
> = ({ value = null }) => {
  const currentValue = value || 0;
  const styles = getStyles(currentValue);

  return (
    <Box>
      <LinearProgress
        color="primary"
        variant="determinate"
        value={currentValue}
        sx={styles}
      />
    </Box>
  );
};
